<template>
  <div class="left_banner" :class="{
    ztColor: $store.state.systemType == 'zongteng',
    top_direction: uiConfig.menuLocation == 'top',
    bottom_direction: uiConfig.menuLocation == 'bottom',
    right_direction: uiConfig.menuLocation == 'right',
  }" :style="{ 'background-color': uiConfig.bannerBgColor }" v-if="isShowLeft">
    <div class="top_logo" v-if="!configs.leftLogoShow">
      <div class="logo" :style="{ backgroundImage: 'url(' + logUrl + ')' }"></div>
    </div>
    <div class="left-nav">
      <ul>
        <li class="avatar_li" v-if="
          uiConfig.userProfile !== 'off' &&
          uiConfig.menuLocation !== 'top' &&
          uiConfig.menuLocation !== 'bottom'
        ">
          <span @click="$router.push({ name: 'myInfo' })">
            <el-badge is-dot :hidden="msgData.length == 0">
              <el-avatar :size="26" :src="$store.state.user.userImage">
                <img :src="$store.state.defaultPhoto" />
              </el-avatar>
            </el-badge>
          </span>
          <div class="msg_pop" v-if="msgData.length > 0">
            <div v-for="(item, index) in msgData" :key="index">
              <p @click="gotoPages(item)">
                <span class="circle_icon"></span>
                {{ $translate("youhave") }}
                <span>{{ item.messessCount }}</span>
                {{
                  $translate("notReadNum") +
                  item.message +
                  $translate("message")
                }}
              </p>
            </div>
          </div>
        </li>
        <template v-for="item in bannerList">
          <router-link :to="{ name: item.route, params: item.params }" tag="li" :key="item.route" class="banner-item"
            v-if="item.isShow" :style="{
              color: setIsActive(item)
                ? uiConfig.bannerFontActiveColor
                : uiConfig.bannerFontDefaultColor,
            }" :class="{ active: setIsActive(item) }"
            @click.native="item.label === 'fill' ? collapseSecondMenu() : null">
            <mu-icon v-if="!item.useSvgIcon" :title="$translate(item.label)" :value="setIsActive(item) ? item.activeIcon : item.icon"
              :size="item.iconSize"></mu-icon>
            <svg-icon v-else :title="$translate(item.label)" :icon-class="setIsActive(item) ? item.activeIcon : item.icon"
              :size="item.iconSize"></svg-icon>
            <div class="item-title">
              {{ $translate(item.label) }}
            </div>
          </router-link>
        </template>
      </ul>
    </div>
    <ul class="nav_footer text-center flex flex_column"
      :style="{ color: uiConfig.bannerFontDefaultColor || '#9f9fa9' }">
      <li class="avatar_li pointer" v-if="
        uiConfig.userProfile !== 'off' &&
        (uiConfig.menuLocation == 'top' ||
          uiConfig.menuLocation == 'bottom')
      ">
        <span @click="$router.push({ name: 'myInfo' })">
          <el-badge is-dot :hidden="msgData.length == 0">
            <el-avatar :size="26" :src="$store.state.user.userImage">
              <img :src="$store.state.defaultPhoto" />
            </el-avatar>
          </el-badge>
        </span>
        <div class="msg_pop" v-if="msgData.length > 0">
          <div v-for="(item, index) in msgData" :key="index">
            <p @click="gotoPages(item)">
              <span class="circle_icon"></span>
              {{ $translate("youhave") }}
              <span>{{ item.messessCount }}</span>
              {{
                $translate("notReadNum") + item.message + $translate("message")
              }}
            </p>
          </div>
        </div>
      </li>
      <li :title="$translate('switchMode')" v-if="
        uiConfig.lightSwitch !== 'off' &&
        uiConfig.menuLocation !== 'top' &&
        uiConfig.menuLocation !== 'bottom'
      " @mouseenter="setColor" @mouseleave="removeColor">
        <mu-icon class="pointer" :size="14" @click="setSystemTheme" :value="$store.state && $store.state.theme == 'light'
            ? 'icon-light_bulb'
            : 'icon-bulb'
          "></mu-icon>
      </li>
      <li :title="$translate('languageswitch')" @mouseenter="setColor" @mouseleave="removeColor" 
        v-show="$store.state.systemType !== 'jd' && uiConfig.languageSwitch !== 'off'
        ">
        <span class="lang-switch pointer" @click="toggleLanguage">中/En</span>
      </li>
      <li v-if="
        uiConfig.fullScreen !== 'off' &&
        uiConfig.menuLocation !== 'top' &&
        uiConfig.menuLocation !== 'bottom'
      " :title="$translate('fullscreen')" @mouseenter="setColor" @mouseleave="removeColor">
        <mu-icon class="pointer" :size="14" @click="toggleFull"
          :value="full ? 'icon-out-full-screen' : 'icon-full-screen'"></mu-icon>
      </li>
      <!-- 帮助文档 -->
      <li v-if="
        uiConfig.helpDocument !== 'off' &&
        uiConfig.menuLocation !== 'top' &&
        uiConfig.menuLocation !== 'bottom'
      " :title="$translate('help')" @mouseenter="setColor" @mouseleave="removeColor">
        <mu-icon class="pointer" :size="16" @click="helpDocument" value="icon-help"></mu-icon>
      </li>
      <!-- 消息中心 -->
      <li v-if="
        uiConfig.messageCenter !== 'off' &&
        uiConfig.menuLocation !== 'top' &&
        uiConfig.menuLocation !== 'bottom'
      " :title="$translate('messageCenter')" @mouseenter="setColor" @mouseleave="removeColor">
        <mu-icon class="pointer" :size="14" @click="messageCenter" value="icon-message"></mu-icon>
      </li>
      <!-- 退出 -->
      <li v-if="
        uiConfig.logout !== 'off' &&
        uiConfig.menuLocation !== 'top' &&
        uiConfig.menuLocation !== 'bottom'
      " :title="$translate('logout')" @mouseenter="setColor" @mouseleave="removeColor">
        <mu-icon class="pointer" :size="14" @click="logout" value="icon-fanhui"></mu-icon>
      </li>

     <!--  <li v-if="
        isShowRobot &&
        uiConfig.clientRobot !== 'off' &&
        uiConfig.menuLocation !== 'top' &&
        uiConfig.menuLocation !== 'bottom'
      " @mouseenter="setColor" @mouseleave="removeColor" :title="$translate('robotguan')">
        <mu-icon class="pointer" :size="15" @click="showRobot" value="icon-robot"
          :color="showRobotStatus ? 'inherit' : 'green'"></mu-icon>
      </li> -->

      <li v-if="uiConfig.leftBannerMore !== 'off'" @mouseenter="setColor" @mouseleave="removeColor">
        <el-dropdown @command="setPath" class="pointer language-select-box" trigger="click" :placement="placement">
          <mu-icon :size="15" :title="$translate('getmore')" value="el-icon-more" style="margin-top: 0"></mu-icon>
          <el-dropdown-menu slot="dropdown" class="left_banner_drop_menu"
            :class="{ light_dropdown: $store.state.theme == 'light' }" :visible-arrow="false" style="margin-top: 14px">
            <el-dropdown-item v-if="
              $store.state.systemConfig &&
              $store.state.systemConfig.angleOfView == 2 &&
              rolesLen > 1
            " command="setRole" class="gray">
              {{ $translate("switchRole") }}
            </el-dropdown-item>
            <el-dropdown-item command="myPage" class="gray"
              v-if="$store.state.uiConfig.myMenu !== 'off' && calculateMyFirstMenu() !== '404'">
              {{ $translate("mine") }}
            </el-dropdown-item>
            <el-dropdown-item command="changeWord" class="gray" v-if="
              $store.state.systemType !== 'jd' &&
              uiConfig.changePassword !== 'off' &&
              showChangePassword
            ">
              {{ $translate("changePassword") }}
            </el-dropdown-item>
            <el-dropdown-item command="userFeedback" v-if="uiConfig.userFeedback !== 'off'" class="gray">
              {{ $translate("userFeedback") }}
            </el-dropdown-item>
            <el-dropdown-item command="help" v-if="uiConfig.helpDocument !== 'off'" class="gray">
              {{ $translate("help") }}
            </el-dropdown-item>
            <el-dropdown-item command="gotoAdmin" class="gray"
              v-if="$store.state.user.isAdmin && uiConfig.admin !== 'off'">
              {{ $translate("adminManage") }}
            </el-dropdown-item>
            <el-dropdown-item command="setting" class="gray" v-if="
              ($store.state.isPortal || $store.state.isBI) &&
              uiConfig.setting !== 'off' &&
              uiConfig.myMenu !== 'off'
            ">
              {{ $translate("setting") }}
            </el-dropdown-item>
            <el-dropdown-item command="logout" class="gray" v-if="uiConfig.logout !== 'off'">
              {{ $translate("quit") }}
            </el-dropdown-item>
            <template v-if="
              uiConfig.menuLocation == 'top' ||
              uiConfig.menuLocation == 'bottom'
            ">
              <el-dropdown-item divided v-if="uiConfig.fullScreen !== 'off'">
                <div @click="toggleFull" :title="$translate('fullscreen')">
                  <mu-icon :size="14" :value="full ? 'icon-out-full-screen' : 'icon-full-screen'"></mu-icon>
                  <span style="margin-left: 1em">{{
                    $translate("fullScreen")
                  }}</span>
                </div>
              </el-dropdown-item>
              <el-dropdown-item v-if="isShowRobot && uiConfig.clientRobot !== 'off'" :title="$translate('robotguan')">
                <mu-icon :size="15" @click="showRobot" value="icon-robot"
                  :color="showRobotStatus ? 'inherit' : 'green'"></mu-icon>
                <span style="margin-left: 1em">{{
                  $translate("robotguan")
                }}</span>
              </el-dropdown-item>
              <el-dropdown-item v-if="uiConfig.lightSwitch !== 'off'">
                <div @click="setSystemTheme">
                  <mu-icon :size="15" :color="$store.state && $store.state.theme == 'light'
                      ? 'green'
                      : 'inherit'
                    " :value="$store.state && $store.state.theme == 'light'
                        ? 'icon-light_bulb'
                        : 'icon-bulb'
                      "></mu-icon>
                  <span style="margin-left: 1em">{{
                    $translate("switchMode")
                  }}</span>
                </div>
              </el-dropdown-item>
            </template>
          </el-dropdown-menu>
        </el-dropdown>
      </li>
    </ul>
    <feedback ref="userFeedback"></feedback>
    <el-dialog width="50%" custom-class="p-dialog" :title="$translate('changePassword')" :close-on-click-modal="false"
      :close-on-press-escape="false" :visible.sync="changeWordDialog">
      <changeWord :close-dialog="closeDialog" v-if="changeWordDialog" />
    </el-dialog>
    <messagePopup
      v-if="importMessage.length"
      :message-data="importMessage"
      position="bottomRight"
      :module="0"
    />
    <messagePopup
      v-if="modulePopupBottomRight.length"
      :message-data="modulePopupBottomRight"
      position="bottomRight"
      :module="activeModule"
      @close="clearModulePopups"
      @read-all="clearModulePopups"
    />
    <messagePopup
      v-if="modulePopupCenter.length"
      :message-data="modulePopupCenter"
      position="center"
      :module="activeModule"
      @close="clearModulePopups"
      @read-all="clearModulePopups"
    />
  </div>
</template>
<script>
const screenfull = require("screenfull");
import { baseUrl } from "../config/env.js";
import feedback from "./feedback";
import changeWord from "../views/login/component/innerWordChange";
import { LoginOut } from "../api/login";
import messagePopup from "@/views/login/messagePopup";
import {
  ANNOUNCEMENT_MODULE,
  fetchModuleAnnouncements,
} from "@/utils/announcementPopup";

export default {
  name: "LeftBanner",
  components: { feedback, changeWord, messagePopup },
  data() {
    return {
      importMessage: [],
      modulePopupBottomRight: [],
      modulePopupCenter: [],
      activeModule: ANNOUNCEMENT_MODULE.Global,
      message: "<img src=1 onerror=alert(2222)>",
      // isShowRobot: window.Robot,
      showRobotStatus: true, //默认为显示
      customMenu: false,
      trigger: null,
      rolesLen: 0, //用来存储当前用户有多少个角色，是否显示角色切换的按钮
      logUrl: baseUrl + "/resourceFile/logo_banner.png?r=" + Math.random(),
      full: screenfull.isFullscreen || false,
      changeWordDialog: false,
      hasDataManagerMenu: false, // 是否显示填报菜单
    };
  },
  computed: {
    showChangePassword() {
      if (this.$route.name !== "changePassword") {
        const { adAutoLogin, adLoginShowPassWord } =
          this.$store.state.systemConfig;
        const { form } = this.$store.state.user;
        if (
          adAutoLogin &&
          adLoginShowPassWord === true &&
          (form == 5 || form == 6)
        ) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    uiConfig() {
      return this.$store.state.uiConfig;
    },
    bannerList() {
      const {
        isShowPortal,
        isShowDesign,
        isEDC,
        isPortal,
        isBI,
        systemType,
        uiConfig,
      } = this.$store.state;
      const home = {
        label: "home",
        route: "customHome",
        icon: "icon-sy_mr",
        activeIcon: "icon-sy_xz",
        iconSize: 24,
        isShow: isShowPortal && uiConfig.homeMenu !== "off",
      };
      const find = {
        label: "find",
        route: "find",
        activeRoute: "find",
        icon: "icon-fx_mr",
        activeIcon: "icon-fx_xz",
        isShow:
          isShowPortal && this.isShowReport && uiConfig.findMenu !== "off",
        iconSize: 24,
      };
      const report = {
        label: "report",
        route: "reportList",
        activeRoute: "report",
        params: { type: "all" },
        icon: "icon-bb_mr",
        activeIcon: "icon-bb_xz",
        iconSize: 24,
        isShow: this.isShowReport && uiConfig.reportMenu !== "off",
      };
      const dataReport = {
        label: "fill",
        route: "mineTask",
        activeRoute: "mineTask",
        params: {},
        /*    icon: "icon-briefcase",
           activeIcon: "icon-briefcase", */
        icon: "icon-sj_mr",
        activeIcon: "icon-sj_xz",
        iconSize: 24,
        isShow: this.$store.state.isEDC,
      };
      const selfServiceAnalysis = {
        label: "selfServiceAnalysis",
        route: "selfServiceAnalysisEmbed",
        activeRoute: "selfServiceAnalysisEmbed",
        params: {},
        icon: "icon-zizhufenxi",
        activeIcon: "icon-zizhufenxi_fanse",
        iconSize: 24,
        isShow: this.$store.state.isSelfServiceAnalysis,
      };
      const xiaoQQuery = {
        label: "xiaoQQuery",
        route: "xiaoQQueryEmbed",
        activeRoute: "xiaoQQueryEmbed",
        params: {},
        icon: "quickbi-xiaoq-query-mr",
        activeIcon: "quickbi-xiaoq-query-xz",
        useSvgIcon: true,
        iconSize: 24,
        isShow: this.$store.state.isXiaoQQuery,
      };
      const xiaoQReport = {
        label: "xiaoQReport",
        route: "xiaoQEmbedReport",
        activeRoute: "xiaoQEmbedReport",
        params: {},
        icon: "quickbi-xiaoq-report-mr",
        activeIcon: "quickbi-xiaoq-report-xz",
        useSvgIcon: true,
        iconSize: 24,
        isShow: this.$store.state.isXiaoQReport,
      };
      const selfServiceDownload = {
        label: "selfServiceDownload",
        route: "selfServiceDownloadEmbed",
        activeRoute: "selfServiceDownloadEmbed",
        params: {},
        icon: "quickbi-zizhuqushu-mr",
        activeIcon: "quickbi-zizhuqushu-xz",
        useSvgIcon: true,
        iconSize: 24,
        isShow: this.$store.state.isSelfServiceDownload,
      };
      const design = {
        label: "design",
        route: "design",
        activeRoute: "design",
        icon: "icon-sj_mr",
        activeIcon: "icon-sj_xz",
        iconSize: 24,
        isShow: isShowDesign && uiConfig.desginMenu !== "off",
      };
      let menuMappingUiConfig = {
        //定义uiconfig和路由的mapping,来判断第一个该跳到哪儿
        mineView: "myBrowsed",
        mineCollect: "myCollection",
        mineTask: "myTask",
        mineMessage: "messageCenter",
        mineComment: "relatedDiscussion",
        myInfo: "personalData",
        mySetting: "mySettings",
        KPIPush: "pushTask",
        browserPlug: "cardPlug",
        pluginMall: "plugInmarket",
        minePage: "myHead",
      };

      const customMenu = {
        label:
          this.$store.state.systemConfig &&
            this.$store.state.systemConfig.clientCustomMenuTitle
            ? this.$store.state.systemConfig.clientCustomMenuTitle
            : "CustomMenu",
        route: "customMenu",
        activeRoute: "customMenu",
        icon: "icon-zdy_mr",
        activeIcon: "icon-zdy_xz",
        iconSize: 24,
        isShow: this.customMenu,
      };
      return [home, find, report, dataReport, selfServiceAnalysis, selfServiceDownload,xiaoQQuery, xiaoQReport, design, customMenu];
    },
    configs() {
      let { clientUIConfig } = this.$store.state.systemConfig;

      if (!clientUIConfig) return {};

      return clientUIConfig;
    },
    placement() {
      let direction = "right";
      switch (this.uiConfig && this.uiConfig.menuLocation) {
        case "left":
          direction = "right";
          break;
        case "right":
          direction = "left";
          break;
        case "top":
          direction = "bottom";
          break;
        case "bottom":
          direction = "top";
          break;
      }
      return direction;
    },

    msgData() {
      let msgData = this.$store.state.msgData;
      let commentCount = 0,
        msgCount = 0,
        atMsg = 0,
        disMe = 0,
        annoMsg = 0,
        loginMsg = 0,
        editUserMsg = 0,
        fansMsg = 0;
      // messageFrom == 1 用户登录   messageFrom == 2 @我的
      // messageFrom == 4 公告消息   messageFrom == 5 粉丝消息    messageFrom == 6 私信消息
      // 消息中心 公告消息 - 4   系统消息 - 1  验证消息 - 6
      //editUserMsg == 7 用户修改信息消息
      msgData.forEach((item) => {
        let message = "";

        switch (item.messageFrom) {
          case 1:
            message = this.$translate("userLogin");
            msgCount += item.messessCount;
            loginMsg = item.messessCount;
            break;
          case 2:
            message = "@" + this.$translate("mine");
            atMsg = item.messessCount;
            commentCount += item.messessCount;
            break;
          case 3:
            message = this.$translate("discussMy");
            // 讨论我的
            commentCount += item.messessCount;
            disMe = item.messessCount;
            break;
          case 4:
            message = this.$translate("notice");
            msgCount += item.messessCount;
            annoMsg = item.messessCount;
            break;
          case 5:
            message = this.$translate("fans");
            fansMsg = item.messessCount;
            msgCount += item.messessCount;
            break;
          case 6:
            message = this.$translate("privateLetter");
            msgCount += item.messessCount;
            break;
          case 7:
            message =
              this.$translate("modify") +
              this.$translate("personalinformation");
            editUserMsg += item.messessCount;
            break;
          default:
            message = this.$translate("message");
            break;
        }

        item.message = message;
      });

      this.$store.commit("setCount", {
        commentCount,
        msgCount,
        atMsg,
        disMe,
        annoMsg,
        loginMsg,
        fansMsg,
        editUserMsg,
      });
      return msgData;
    },
    isShowRobot() {
      return this.$store.state.isRobot;
    },
    isShowLeft() {
      if (
        this.$store.state.systemType == "jd" &&
        (this.$route.name === "reportView" ||
          this.$route.name === "findView" ||
          this.$route.name === "myReportView")
      ) {
        return false;
      } else {
        return !this.full;
      }
    },
    isShowReport() {
      if (!this.$store.state.isEDC && this.$store.state.isPortal) {
        return true;
      } else if (this.$store.state.isPortal) {
        return true;
      } else if (this.$store.state.isBI) {
        return true;
      } else {
        return false;
      }
    },
    editUserMsg() {
      return this.$store.state.editUserMsg;
    },
  },
  watch: {
    editUserMsg(val) {
      if (val && val != 0) {
        this.importMessage.push({
          content: this.$translate("YourInfoHasBeenModified"),
          title: this.$translate("systemMessage"),
          type: "userInfo",
        });
      } else if (val == 0) {
        this.importMessage = this.importMessage.filter(
          (item) => item.type !== "userInfo"
        );
      }
    },
  },
  mounted() {
    this.getInitMessage();
    this.openImportNotice();
    this.$root.$on("open-module-announcement", this.onModuleAnnouncement);
    //this.checkDataManagerMenu(); // 检查是否有数据管理菜单权限
    this.$api.Roles.GetRoleByUser().then((res) => {
      if (res) {
        this.rolesLen = res.data.length || 0;
      }
    });

    if (screenfull.enabled) {
      screenfull.on("change", () => {
        this.full = screenfull.isFullscreen;
      });
    }
    const { systemConfig, isShowPortal } = this.$store.state;

    if (systemConfig && systemConfig.clientCustomMenuEnabled && isShowPortal) {
      this.$api.ClientMenu.GetClientMenusByUserId().then((res) => {
        if (!res) return;
        let infoData = res.data || {},
          treeSource = infoData.children || [];

        if (treeSource.length > 0) {
          this.customMenu = true;
        }
      });
    }
  },
  methods: {
    // 计算myFirstMenu的方法
    calculateMyFirstMenu() {
      const {
        isShowPortal,
        isShowDesign,
        isEDC,
        isPortal,
        isBI,
        systemType,
        uiConfig,
      } = this.$store.state;

      let menuMappingUiConfig = {
        //定义uiconfig和路由的mapping,来判断第一个该跳到哪儿
        mineView: "myBrowsed",
        mineCollect: "myCollection",
        mineTask: "myTask",
        mineMessage: "messageCenter",
        mineComment: "relatedDiscussion",
        myInfo: "personalData",
        mySetting: "mySettings",
        KPIPush: "pushTask",
        browserPlug: "cardPlug",
        pluginMall: "plugInmarket",
        minePage: "myHead",
      };

      let myFirstMenu = "about";
      if (isEDC && !isPortal && uiConfig.myTask !== "off") {
        myFirstMenu = "datamanagement";
      }
      if (
        !isEDC &&
        (!isPortal || !isBI)  &&
        systemType !== "jd" &&
        uiConfig.personalData !== "off"
      ) {
        myFirstMenu = "myInfo";
      }
      if (myFirstMenu == "about" && uiConfig.myBrowsed == "off") {
        //如果第一个菜单被隐藏了，就找到没有设置隐藏的那个菜单，如果都隐藏了就跳到404
        let isHasMenu = false;
        for (const key in menuMappingUiConfig) {
          const mappingName = menuMappingUiConfig[key];
          if (uiConfig[mappingName] !== "off") {
            myFirstMenu = key == "minePage" ? "myInfo" : key;
            isHasMenu = true;
            break;
          }
        }
        if (!isHasMenu) {
          myFirstMenu = "404";
        }
      }

      return myFirstMenu;
    },
    // 检查是否有数据管理菜单权限
    checkDataManagerMenu() {
      if (this.$store.state.user.id) {
        this.$api.InitiationWorkFlow.GetHasDataManagerMenu({
          userId: this.$store.state.user.id,
          token: localStorage.clientToken,
        }).then((res) => {
          if (res && res.isSuccess) {
            this.hasDataManagerMenu = res.data.isDataManager;
          }
        });
      }
    },
    openImportNotice() {
      this.loadModuleAnnouncement(ANNOUNCEMENT_MODULE.Global);
    },
    clearModulePopups() {
      this.modulePopupBottomRight = [];
      this.modulePopupCenter = [];
    },
    async loadModuleAnnouncement(module) {
      const result = await fetchModuleAnnouncements(this.$api, module);
      if (!result) return;
      this.activeModule = module;
      this.modulePopupBottomRight = result.bottomRight;
      this.modulePopupCenter = result.center;
    },
    onModuleAnnouncement(module) {
      this.loadModuleAnnouncement(module);
    },
    setColor($event) {
      $event.target.style.color = this.uiConfig.bannerFontActiveColor || "#FFF";
    },
    removeColor($event) {
      $event.target.style.color = "inherit";
    },
    closeDialog() {
      this.changeWordDialog = false;
    },
    setSystemTheme() {
      this.$store.commit("setTheme");
    },
    setIsActive(item) {
      const routeName = this.$route.name;
      const routePath = this.$route.path;

      if (routeName === item.route) {
        return true;
      }

      if (item.label === "report") {
        return (
          routePath === "/report" ||
          routePath.startsWith("/report/") ||
          routeName === "subview"
        );
      }

      if (item.activeRoute === "mineTask") {
        return [
          "mineTask",
          "tasktodo",
          "taskdone",
          "initprocess",
          "myfile",
          "datamanagement",
          "dataMaintain",
          "checkProcess",
          "checkData",
          "checkForm",
        ].includes(routeName);
      }

      if (item.activeRoute && routeName === item.activeRoute) {
        return true;
      }

      if (item.activeRoute && routePath.indexOf(item.activeRoute) > -1) {
        return true;
      }

      return false;
    },
    showRobot() {
      let dom = document.querySelector("#botBtn");
      if (dom) {
        if (dom.classList.contains("none")) {
          dom.classList.remove("none");
          this.showRobotStatus = true;
        } else {
          dom.classList.add("none");
          this.showRobotStatus = false;
        }
      }
    },
    setPath(val) {
      console.log("setPath val", val);
      if (val == "logout") {
        this.$confirm(this.$translate("sureToQuit"), {
          confirmButtonText: this.$translate("sure"),
          cancelButtonText: this.$translate("cancel"),
          type: "warning",
        }).then(async () => {
          await LoginOut();
          this.$store.commit("logout");
        });
      } else if (val == "myPage") {
        // 导航到"我的"页面并显示二级菜单
        this.showSecondMenu();
      } else if (val == "setting") {
        // mySetting
        this.$router.push({ name: "mySetting" });
      } else if (val == "setRole") {
        this.$router.push({ name: "CheckLicense" });
      } else if (val == "changeWord") {
        // this.$router.push({ name: "changeWord" });
        this.changeWordDialog = true;
      } else if (val == "gotoAdmin") {
        const isToken = !!localStorage.clientToken;
        if (isToken) {
          let queryObj = {
            token: localStorage.clientToken,
          };

          if (localStorage.clientGlobalRole) {
            localStorage.globalRole = localStorage.clientGlobalRole;
          }
          if (localStorage.clientReturnUrl) {
            queryObj.returnUrl = localStorage.clientReturnUrl;
          }
          if (localStorage.clientisssoout) {
            queryObj.isssoout = localStorage.clientisssoout;
          }
          localStorage.token = queryObj.token;

          let queryString = null;

          Object.keys(queryObj).forEach((key, index) => {
            if (index == 0) {
              queryString = `?${key}=${queryObj[key]}`;
            } else {
              queryString += `&${key}=${queryObj[key]}`;
            }
          });
          const openUrl = this.$getOrigin(
            `/${this.$store.state.adminName}/#/${queryString}`
          );

          window.open(openUrl);
        }
      } else if (val == "userFeedback") {
        this.$refs.userFeedback.dialogVisible = true;
      } else if (val == "help") {
        window.open(`${window.location.protocol}//${window.location.host}/portalbasicapi/ResourceFile/DownFilePdfByReportCode/help`);
      }
    },
    gotoPages(item) {
      let routeName = "";
      if (item.messageFrom == 1 || item.messageFrom == 7) {
        routeName = "systemmsg";
      } else if (item.messageFrom == 2) {
        routeName = "callme";
      } else if (item.messageFrom == 3) {
        routeName = "tome";
      } else if (item.messageFrom == 4) {
        routeName = "announcement";
      } else if (item.messageFrom == 5 || item.messageFrom == 6) {
        routeName = "mymsg";
      }
      this.$router.push({ name: routeName });
    },

    toggleFull() {
      if (screenfull.enabled) {
        screenfull.toggle().then(() => {
          this.full = screenfull.isFullscreen;
        });
      }
    },
    helpDocument() {
      window.open(`${window.location.protocol}//${window.location.host}/portalbasicapi/ResourceFile/DownFilePdfByReportCode/help`);
    },
    messageCenter() {
      // 点击消息中心时直接跳转到消息公告页面
      // 参考填报菜单的实现方式，直接导航到对应路由
      this.$router.push({
        name: 'announcement'  // 使用路由名跳转到消息中心的公告页面
      });
    },
    logout() {
      this.$confirm(this.$translate("sureToQuit"), {
        confirmButtonText: this.$translate("sure"),
        cancelButtonText: this.$translate("cancel"),
        type: "warning",
      }).then(async () => {
        await LoginOut();
        this.$store.commit("logout");
      });
    },
    getInitMessage() {
      this.$api.Message.GetMessageCollection().then((res) => {
        if (res && res.isSuccess) {
          let msgData = res.data;
          this.$store.commit("socketMessage", { data: msgData, isHttp: true });
        }
      });
    },
    collapseSecondMenu() {
      // 在点击填报菜单时折叠二级菜单，直接导航到mineTask
     /*  this.$router.push({
        name: 'mineTask'
      }); */
      // 在点击填报菜单时直接导航到数据管理页签
      this.$router.push({
        name: 'datamanagement',
        params: {type: 'dataManagement'}
      });
    },

    showSecondMenu() {
      // 在点击"我的"菜单时显示二级菜单
      // 通过设置query参数通知aboutMe组件显示二级菜单
      const myFirstMenu = this.calculateMyFirstMenu();
      this.$router.push({
        name: myFirstMenu,
        query: { showSecondMenu: 'true' }
      });
    },

    findAboutMeInstance() {
      // 不再需要此方法
      return null;
    },

    findComponentInstanceByName(instance, name) {
      // 不再需要此方法
      return null;
    },

    toggleLanguage() {
      
      const newLang = localStorage.language === 'zh' ? 'en' : 'zh';
      
      // 调用API切换语言
      import("@/api/config").then(module => {
        const { SetLanguage } = module;
        SetLanguage(newLang).then(res => {
          if (res && res.isSuccess) {
            this.$store.commit("setUserLanguage", newLang);
            location.reload(); // 重新加载页面以应用新语言
          }
        });
      });
    },
  },
  beforeDestroy() {
    this.$root.$off("open-module-announcement", this.onModuleAnnouncement);
  },
};
</script>
<style lang="scss" scoped>
$leftWidth: 60px;
$fullWidth: 100%;

// $bannerBg: #1d3753;
.left_banner {
  width: $leftWidth;
  background-color: $mainColor;
  position: relative;

  // z-index: 99;
  &.ztColor {
    background-color: rgb(5, 29, 73);
  }

  .top_logo {
    width: 100%;
    height: $leftWidth;
    text-align: center;
    padding: 14px 8px;

    .logo {
      width: 100%;
      height: 100%;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center center;
    }
  }

  .left-nav {
    /* padding-top: 1em; */
    text-align: center;

    ul {
      li+li {
        margin-top: 2.1vh;
      }

      li {
        cursor: pointer;
        font-size: 12px;
        color: #9f9fa9;

        // * {
        //   color: #9f9fa9;
        // }
        &.active {
          position: relative;
          color: #ffffff;

          &::after {
            content: "";
            display: block;
            width: 0;
            height: 0;
            border-top: 6px solid transparent;
            border-left: 6px solid transparent;
            border-right: 6px solid #f4f4f4;
            border-bottom: 6px solid transparent;
            position: absolute;
            right: 0;
            top: 50%;
            z-index: 99;
          }

          * {
            color: inherit;
            
          }
        }
      }
    }
  }

  .avatar_li {
    position: relative;

    &:hover>.msg_pop {
      width: auto;
      white-space: nowrap;
      height: auto;
      padding: $padding10 $margin15;
    }
  }

  .msg_pop {
    position: absolute;
    top: -10px;
    min-width: 220px;
    // width: 200px;
    height: 0;
    left: $leftWidth;
    z-index: 99999;
    background-color: $msgPopColor;
    opacity: 0.9;
    border-radius: 4px;
    transition: all 0.5s ease-in-out;
    overflow: hidden;

    p {
      padding: $padding10 0;
      text-align: left;
      color: $white;

      .circle_icon {
        display: inline-block;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-color: $white;
        margin-right: $padding10;
      }

      span {
        color: $msgCountColor;
      }
    }
  }

  .nav_footer {
    position: absolute;
    bottom: 0;
    padding: 15px 0;
    width: 100%;

    li {
      color: inherit;

      * {
        color: inherit;
      }
    }

    // li:hover * {
    //   color: #f5f5f5 !important;
    // }
    .banner-item {
      padding: 15px 0;
    }
  }

  &.top_direction .left-nav ul,
  &.bottom_direction .left-nav ul {
    li.active::after {
      width: 100%;
     
      height: 3px;
      background-color: #fff;
      border: none;
      // right: 50%;
      bottom: -14px;
      // border-radius: 2px 2px 0 0;
      top: inherit;
      // z-index: 99;
      // transform: rotate(90deg) translateY(-50%);
    }
  }

  &.bottom_direction .msg_pop {
    bottom: 50px;
    right: 10px;
    left: inherit;
    top: inherit;
  }

  &.top_direction .msg_pop {
    top: 50px;
    right: 10px;
    left: inherit;
  }

  &.right_direction .msg_pop {
    right: $leftWidth;
    left: inherit;
  }
}

.left_banner.top_direction,
.left_banner.bottom_direction {
  height: 50px;
  width: $fullWidth;
  display: flex;
  align-items: center;
  flex-direction: row;

  .top_logo {
    width: 160px;
    height: 100%;

    .logo {
      background-position: left center;
    }
  }

  .left-nav {
    padding-top: 0;

    ul {
      display: flex;
      width: auto;
      align-items: center;
      flex-direction: row;

      .mu-icon {
        display: none;
      }

      li+li {
        margin-top: 0;
      }

      .avatar_li {
        position: absolute;
        right: 160px;
      }
    }

    .item-title {
      font-size: 14px !important;
    }

    @media only screen and (max-height: 600px) {
      .banner-item .item-title {
        display: inherit;
      }
    }
  }

  .nav_footer {
    right: 15px;
    display: flex;
    width: auto !important;
    flex-direction: row;
  }

  li {
    margin-left: 1em;
  }
}

.left_banner_drop_menu {
  /deep/ .el-dropdown-menu__item--divided:before {
    height: 0;
  }
}

.lang-switch {
  font-size: 13px;
  font-weight: bold;
  color: inherit;
  cursor: pointer;
  padding: 0 2px;
  display: inline-block;
  transition: all 0.3s;
  &:hover {
    color: #409EFF;
    transform: scale(1.05);
  }
}
</style>
